import { Grid } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useFormContext } from "react-hook-form";
import { FilterModel } from "../models/FilterModel";
import AddressPointSelect from "./fields/AddressPointSelect";
import StreetSelect from "./fields/StreetSelect";

const Filters = () => {
  const { formState } = useFormContext<FilterModel>();
  return (
    <Grid container spacing={3}>
      {Object.keys(formState.errors).length > 0 && (
        <Grid sx={visuallyHidden} role="alert" item xs={12}>
          Formularz zawiera poniższe błędy:
          <ul>
            {Object.entries(formState.errors).map(([key, error]) => (
              <li key={key}>{error.message}</li>
            ))}
          </ul>
        </Grid>
      )}
      <Grid item xs={12}>
        <StreetSelect />
      </Grid>
      <Grid item xs={12}>
        <AddressPointSelect />
      </Grid>
    </Grid>
  );
};

export default Filters;
